var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHarnessRacing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10002_5248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 7.87036V7.90161C13.9688 8.83911 13.5938 9.68286 13 10.2766V15.4016C13 15.9641 12.5312 16.4016 12 16.4016H11C10.4375 16.4016 10 15.9641 10 15.4016V11.2454C9.84375 11.2141 9.71875 11.2141 9.59375 11.1516L8 10.7141V8.24536C9.15625 7.83911 10 6.71411 10 5.40161V4.40161C10 2.21411 11.7812 0.401611 14 0.401611H15H17.5C17.75 0.401611 18 0.651611 18 0.901611C18 1.18286 17.75 1.40161 17.5 1.40161H17.3125C17.7188 1.77661 18 2.30786 18 2.90161V5.27661C18 5.96411 17.5625 6.58911 16.9375 6.83911C16.125 7.15161 15.1875 6.80786 14.7812 6.02661L14.5 5.40161H14V7.87036ZM7 10.4016V10.4329L6.96875 10.4016C7 10.4954 7 10.5579 7 10.6204C7 11.2141 6.75 11.7766 6.34375 12.1829L5.9375 12.5891C5.8125 12.7454 5.75 12.9641 5.8125 13.1516L6.46875 15.0891C6.6875 15.7454 6.1875 16.4329 5.5 16.4329H4.46875C4.03125 16.4329 3.65625 16.1516 3.5 15.7454L2.96875 14.0891C2.625 13.1204 2.75 12.0266 3.28125 11.1516C3.5 10.7454 3.5625 10.2454 3.3125 9.87036L2.4375 8.52661C2.21875 8.18286 2.0625 7.80786 2 7.40161C1.6875 7.62036 1.5 7.99536 1.5 8.40161V10.1516C1.5 10.5891 1.15625 10.9016 0.75 10.9016C0.3125 10.9016 0 10.5891 0 10.1516V8.40161C0 7.02661 1.03125 5.87036 2.375 5.68286C2.71875 5.12036 3.3125 4.68286 4 4.49536V5.40161C4 7.05786 5.34375 8.40161 7 8.40161V10.4016ZM9 5.40161C9 6.52661 8.09375 7.40161 7 7.40161C5.875 7.40161 5 6.52661 5 5.40161V4.40161H6.34375H7H9V5.40161ZM15.5 2.40161C15.2188 2.40161 15 2.65161 15 2.90161C15 3.18286 15.2188 3.40161 15.5 3.40161C15.75 3.40161 16 3.18286 16 2.90161C16 2.65161 15.75 2.40161 15.5 2.40161Z",
    fill: "currentColor",
    fillOpacity: 1,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10002_5248",
    x: 0,
    y: 0.401611,
    width: 18,
    height: 17.0312,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10002_5248"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10002_5248",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHarnessRacing);
export default ForwardRef;